<template lang="pug">
//- home-main
.home-main
  .hello-word Hi , {{ $root.user.name }} !
  .hello-text 讓我們來看看你今天有哪些課程。

  //- 切換 您的課程 / 推薦課程 按鈕
  .switch-button-box
    .home-switch-btn.button(
      v-bind:class="!switch_status ? 'btn-default' : 'btn-no-default'",
      @click="clickSwitch(false)"
    ) 您的課程
    //- .home-switch-btn.button(
    //-   v-bind:class="switch_status ? 'btn-default' : 'btn-no-default'",
    //-   @click="clickSwitch(true)"
    //- ) 推薦課程

  //- 日期組件
  DateCom(
    use_type="home",
    :date_turn="date_turn",
    :date_filter="date_filter",
    @dateTurn="dateTurn",
    @setDate="setCourseDate"
  )
  //- 今日推薦
  TodayRecommend
</template>
<script>
import DateCom from '@/components/date'
import TodayRecommend from '@/components/home/today-recommend'
export default {
  name: 'homeMain',
  props: ['switch_status'],
  components: {
    DateCom,
    TodayRecommend
  },
  data () {
    return {
      //- 課程表格切換
      timetable_switch: false,
      //- 日期開關
      date_turn: false,
      //- 日期篩選狀態
      date_filter: this.$root.common.getNowTime('date'),
      //- 語言篩選狀態
      language_filter: 'all',
      //- 課程篩選狀態
      class_filter: 'all',
    };
  },
  methods: {
    dateTurn () {
      this.$data.date_turn = !this.$data.date_turn
    },
    switchTimeTable (_status) {
      this.timetable_switch = _status
    },
    //- 切換右方時間表
    clickSwitch (_status) {
      this.$emit('clickSwitch', _status)
    },
    // 設定課程語言
    setCourseLange (_langID) {
      this.language_filter = _langID
    },
    // 設定課程類別
    setCourseType (_courseType) {
      this.class_filter = _courseType
    },
    // 設定課程日期
    setCourseDate (_courseDate) {
      this.date_filter = _courseDate
    }
  }
}
</script>
